const sentryConfig = {
    sentry: {
        key: 'f099735edc334b8e817b0ce1d8274f3f',
        project: '1410747'
    }
};

const driftConfig = {
    drift: {
        appId: '4dhuzx6zgz3g'
    }
};

const pollConfig = {
    intervalMsec: 10 * 60 * 1000, // 10 minutes
    // intervalMsec: 10 * 1000, // 10 seconds
    feVersion: 'e0.1.67'
};

const devConfig = {
    s3: {
        BUCKET: 'gl-dev-test',
        REGION: 'us-west-2'
    },
    apiGateway: {
        REGION: 'us-west-1',
        URL: 'https://api.greenlight.ai/dev'
    },
    cognito: {
        REGION: 'us-west-2',
        USER_POOL_ID: 'us-west-2_W89u3rFq7',
        APP_CLIENT_ID: '7eknap97lml11fqmt6tlk9oj0f'
    },
    mixpanel: {
        key: '48d056d7291e21a59452e1c14dbb4dac'
    },
    hotjar: {
        hjid: '1437799',
        hjsv: '6'
    },
    ...driftConfig,
    ...sentryConfig,
    ...pollConfig,
    test: {
        url: 'https://dev.greenlight.ai/'
    }
};

export default {
    STAGE: process.env.REACT_APP_STAGE || 'local',

    MAX_ATTACHMENT_SIZE: 10000000,

    // AWS development environment
    dev: {
        ...devConfig
    },

    local: {
        ...devConfig,
        apiGateway: {
            ...devConfig.apiGateway
        },
        test: {
            url: 'http://localhost:3000'
        }
    },

    adhoc: {
        ...devConfig,
        apiGateway: {
            ...devConfig.apiGateway,
            URL: 'https://api.greenlight.ai/adhoc'
        },
        test: {
            url: 'https://adhoc.greenlight.ai/'
        }
    },

    // AWS staging environment
    staging: {
        s3: {
            BUCKET: 'gl-staging-test',
            REGION: 'us-west-2'
        },
        apiGateway: {
            REGION: 'us-west-1',
            URL: 'https://api.greenlight.ai/staging'
        },
        cognito: {
            REGION: 'us-west-2',
            USER_POOL_ID: 'us-west-2_jC9b0Sw4A',
            APP_CLIENT_ID: '7n319a91tiq4bn8j4dh3bcteai'
        },
        mixpanel: {
            key: '48d056d7291e21a59452e1c14dbb4dac'
        },
        test: {
            url: 'https://staging.greenlight.ai/'
        },
        ...sentryConfig,
        ...driftConfig,
        ...pollConfig
    },

    // AWS beta environment
    beta: {
        s3: {
            BUCKET: 'gl-beta-test',
            REGION: 'us-west-2'
        },
        apiGateway: {
            REGION: 'us-west-1',
            URL: 'https://api.greenlight.ai/beta'
        },
        cognito: {
            REGION: 'us-west-2',
            USER_POOL_ID: 'us-west-2_hHxuZaBIE',
            APP_CLIENT_ID: '6rrj6017fd7fpg7r37vuqor8lq'
        },
        mixpanel: {
            key: 'b372a9dcd88cfd77e46399de8acda2db'
        },
        hotjar: {
            hjid: '1437796',
            hjsv: '6'
        },
        test: {
            url: 'https://beta.greenlight.ai/'
        },
        ...driftConfig,
        ...sentryConfig,
        ...pollConfig
    },

    // AWS production environment
    app: {
        s3: {
            BUCKET: 'gl-app-test',
            REGION: 'us-west-2'
        },
        apiGateway: {
            REGION: 'us-west-1',
            URL: 'https://api.greenlight.ai/app'
        },
        cognito: {
            // will need to change once app is set up
            REGION: 'us-west-2',
            USER_POOL_ID: 'us-west-2_hHxuZaBIE',
            APP_CLIENT_ID: '6rrj6017fd7fpg7r37vuqor8lq'
        },
        mixpanel: {
            key: 'b372a9dcd88cfd77e46399de8acda2db'
        },
        test: {
            url: 'https://app.greenlight.ai/'
        },
        ...driftConfig,
        ...sentryConfig
    }
};



// WEBPACK FOOTER //
// ./src/configuration/server.js